import { render, staticRenderFns } from "./IntroduceUsers.vue?vue&type=template&id=45a681c1"
import script from "./IntroduceUsers.vue?vue&type=script&lang=js"
export * from "./IntroduceUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports